import React, { useEffect, useState, useContext } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Table } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
// import "./AddPurchaseTable.css"
import plus from "../../assets/Plus.svg";
import LogicContext from "../../Context/LogicContext";
import { NumericFormat } from 'react-number-format';
import { TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import BillTaxComponent from "./BillTaxComponent";
import BillCustomerComponent from "./BillCustomerComponent";
import BillAccountComponent from "./BillAccountComponent";
import BillSearchItems from "./BillSearchItems";

function AddBillTable(props) {
  const [itemTableList, setItemTableList] = useState([]);
  const [tempSelection, setTempSelection] = useState({});
  const logicContext = useContext(LogicContext);

  const currentSelectedItem = (item) => {
    setTempSelection({ ...item, Item_Quantity: 1, Item_Rate: item.Rate, Account_Id:0 , Item_Amount:0, Tax_Id:0, Customer_Id:0});
  }


  const AddToTable = () => {
    if (tempSelection?.Item_Id) {
      const found = itemTableList.find(element => element.Item_Id === tempSelection.Item_Id);
      if (found) {
        return logicContext.showToast('Selected item already in selection', 'error');
      }
      setItemTableList((prev) => {
        return ([...prev, { ...tempSelection }])
      });
      props?.onSelectionList([...itemTableList, { ...tempSelection }]);

    } else {
      return logicContext.showToast('Please select an item', 'info');
    }
  }


  useEffect(() => {
    let timeoutId;
      if (props?.defaultList?.length > 0) {
        setItemTableList(props?.defaultList);
        
        timeoutId = setTimeout(() => {
          props?.onSelectionList([...props?.defaultList])
        }, 2500);
      }
    return () => {
      clearTimeout(timeoutId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.defaultList?.length])



  const onQuantityChange = (qty, index) => {
    const newQty = parseFloat(qty)
    if (newQty > 0) {
      const currentItem = itemTableList[index];
      const newList = itemTableList?.map((item) => {
        if (item.Item_Id === currentItem.Item_Id) {
          return { ...item, Item_Quantity: parseFloat(newQty) }
        } else {
          return item;
        }

      });
      setItemTableList([...newList]);
      props?.onSelectionList([...newList])

    } else {

      setItemTableList([...itemTableList]);
    }



  }



  const onRateChange = (qty, index) => {
    const newQty = parseFloat(qty)
    if (newQty > 0) {
      const currentItem = itemTableList[index];
      const newList = itemTableList?.map((item) => {
        if (item.Item_Id === currentItem.Item_Id) {
          return { ...item, Item_Rate: parseFloat(newQty) }
        } else {
          return item;
        }

      });
      setItemTableList([...newList]);
      props?.onSelectionList([...newList])

    } else {

      setItemTableList([...itemTableList]);
    }



  }




  function deleteItemFromTable(removedItem) {
    const newList = itemTableList.filter((item) => item.Item_Id !== removedItem.Item_Id);
    setItemTableList(newList);
    props?.onSelectionList(newList);
  }



  function onTaxSelect(data, index) {
    const currentItem = itemTableList[index];
    const newList = itemTableList?.map((item) => {
      if (item.Item_Id === currentItem.Item_Id) {
        return { ...item, Item_Tax_Id: data.Tax_Id }
      } else {
        return item;
      }

    });
    setItemTableList(newList);
    props?.onSelectionList(newList);
  }


  function onCustomerSelect(data, index) {
   
    const currentItem = itemTableList[index];
    const newList = itemTableList?.map((item) => {
      if (item.Item_Id === currentItem.Item_Id) {
        return { ...item, Item_Tax_Id: data.Customer_Id }
      } else {
        return item;
      }

    });
    setItemTableList(newList);
    props?.onSelectionList(newList);
  }


  function onAccountSelect(data, index) {
    const currentItem = itemTableList[index];
    const newList = itemTableList?.map((item) => {
      if (item.Item_Id === currentItem.Item_Id) {
        return { ...item, Account_Id: data.Account_Id }
      } else {
        return item;
      }

    });
    setItemTableList(newList);
    props?.onSelectionList(newList);
  }





  return (
    <section className=" mt-2 max-auto border-2 py-2 px-2 max-w-6xl text-filterTextColor">
      <section className=" ">
        <section className=" mt-1 right-1   md:  ">
          <section className="">
            <section className="profile_section ">
              <div className="  ">
                <div className="flex  justify-between w-full">
                  {" "}
                  <BillSearchItems currentSelectedItem={currentSelectedItem} />

                  <div onClick={AddToTable}
                    style={{ borderRadius: "5px" }}
                    className=" btn rounded mt-4  px-3 h-[5.8vh] text-filterTextColor bg-filterColor  ml-1 " >
                    <img src={plus} alt="" />
                  </div>

                  <div>

                  </div>
                </div>
              </div>
              {/* end */}

              <section className="mt-3">
                {/*  start table */}
                <div className=" ">
                  <TableContainer className="mt-3 mb-5  h-[30vh]">
                    <Table  sx={{ minWidth: 650 }} aria-label="simple table">
                    <colgroup>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'10%'}}/>
                    <col style={{width:'10%'}}/>
                    <col style={{width:'20%'}}/>
                    <col style={{width:'15%'}}/>
                    <col style={{width:'5%'}}/>
                </colgroup>
                      <TableHead style={{ backgroundColor: "#F1F1F1" }}>
                        <TableRow>
                          <TableCell className="font-bold" >Item Details</TableCell>
                          <TableCell className="font-bold">Account</TableCell>
                          <TableCell className="font-bold">Quantity</TableCell>
                          <TableCell className="font-bold">Rate</TableCell>
                          <TableCell className="font-bold">Tax</TableCell>
                          <TableCell className="font-bold">Customer Details</TableCell>
                          <TableCell className="font-bold">Amount</TableCell>
                          <TableCell></TableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {itemTableList?.map((item, i)=> {

                      return (
                        <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }} >
                        <TableCell className="Table2" style={{ width: "120px " }}  align="left">
                        <span>  {item.Item_Name}</span>
                        </TableCell>
                        {/* Account_Id */}

                        <TableCell align="left">  
                          <BillAccountComponent defaultVal={{label: item.Account_Name}} onAccountSelect={(data)=> onAccountSelect(data, i)} />
                          </TableCell>

                        <TableCell  align="left">
                        
                              <NumericFormat
                              value={item.Item_Quantity?.toFixed(2)}
                              style={{ width: "120px" }}
                              // thousandSeparator=","
                              // decimalSeparator="."
                              allowedDecimalSeparators={['%']}
                              onValueChange={(values, sourceInfo) => {
                                onQuantityChange(parseFloat(Number(values.value)), i)
                              }}
                            />
                        </TableCell>

                        <TableCell align="left"> 
                      <NumericFormat
                              value={item.Item_Rate?.toFixed(2)}
                              style={{ width: "120px" }}
                              // thousandSeparator=","
                              // decimalSeparator="."
                              // allowedDecimalSeparators={['.']}
                              onValueChange={(values, sourceInfo) => {
                                onRateChange(values.value, i)
                              }}
                            />

                          </TableCell>

                        <TableCell align="left"> 
                          <BillTaxComponent defaultVal={{label: item?.Tax_Name}} onTaxSelect={(data)=> onTaxSelect(data, i)} />
                        </TableCell>

                        <TableCell align="left"> 
                          <BillCustomerComponent defaultVal={{label: item?.Tax_Name}} onCustomerSelect={(data)=> onCustomerSelect(data, i)} />
                        </TableCell>

                        <TableCell align="left">
                          <CurrencyFormat
                          className={"font-bold " }
                            value={parseFloat(item.Item_Quantity * item.Item_Rate)?.toFixed(2)}
                            displayType={"text"}  thousandSeparator={true} prefix={"₦"} />
                        </TableCell>

                        <TableCell align="left">
                          <DeleteIcon color="error" onClick={()=>deleteItemFromTable(item)} />
                        </TableCell>

                      </TableRow>
                        
                      )
                      })}
                 

                      </TableBody>
                    </Table>
                  </TableContainer>


                </div>

                {/* end table */}

              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  );
}

export default AddBillTable;
